module.exports = __webpack_public_path__ + "img/23.7e0dce6d.jpg";